import React, { useState, useEffect } from 'react';
import api from '../api';

const BUCKETS = ['Current', '1-30', '31-60', '61-90', '90+'];

const Ageing = () => {
  const [rows, setRows] = useState([]);
  const [kind, setKind] = useState('member');
  const [asOf, setAsOf] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = (type = kind) => {
    setLoading(true);
    api.get(`/ageing/?type=${type}`)
      .then(res => {
        setRows(res.data.rows || []);
        setAsOf(res.data.as_of || '');
        setKind(res.data.type || type);
      })
      .catch(() => setError('Failed to load ageing data'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load('member'); }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex-between">
        <h2>Ageing Analysis {asOf ? `(as of ${asOf})` : ''}</h2>
        <div>
          <button className={`btn ${kind === 'member' ? 'btn-primary' : 'btn-outline'}`} onClick={() => load('member')} style={{ marginRight: 8 }}>
            By Member
          </button>
          <button className={`btn ${kind === 'supplier' ? 'btn-primary' : 'btn-outline'}`} onClick={() => load('supplier')}>
            By Supplier (AP)
          </button>
        </div>
      </div>
      {error && <div className="error">{error}</div>}
      <table className="table">
        <thead>
          <tr>
            <th>{kind === 'supplier' ? 'Supplier' : 'Member'}</th>
            {BUCKETS.map(b => <th key={b}>{b}</th>)}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.name}>
              <td>{r.name}</td>
              {BUCKETS.map(b => (
                <td key={b}>{Number(r[b] || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
              ))}
              <td>{Number(r.total || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={BUCKETS.length + 2}>No purchase data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Ageing;
